"use client"
import { useContext } from "react"
import { ScrollContext } from "./context"

export const useScrollWithSections = () => {
  const { scrollTo, selected, refs } = useContext(ScrollContext)
  let selectedSectionItem = { title: "" }
  const sections = Object.keys(refs).map((id) => {
    const item = {
      id,
      title: refs[id]?.current?.dataset?.title || "",
      onClick: () => scrollTo(id),
      selected: selected === id,
    }
    if (selected === id) selectedSectionItem = item
    return item
  })
  return { selected, sections, selectedSectionItem }
}
